// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","largeWidth":"1200px","addButton":"AddNewCategory_addButton__2M2Vh"};